import moment from "moment";
import { images } from "../../../../assets";
import {
  isKeyOfStatus,
  isKeyOfSubestatus,
  STATUS_DIC,
  SUBSTATUS_DIC,
} from "../../../../constants/clientsDebtRecovery";
import { Action, Column, TableProps } from "../../../../components/table-simple/table.types";
import { RequestItem } from "../../../../services/DebtRecoveryServices.dto";

const columns: Column[] = [
  { title: "NIF Tomador", key: "takerNif", position: "left" },
  { title: "Código de Pedido", key: "requestId", position: "left" },
  { title: "Fecha de Alta", key: "createdAt", position: "left" },
  { title: "Estado Solicitud", key: "status", position: "left" },
  { title: "Subestado Solicitud", key: "subStatus", position: "left" },
  { title: "Fecha última actualización", key: "updatedAt", position: "left" },
];

function formatDate(date: string): string {
  return moment(date).format("DD/MM/YYYY");
}

function getStatusName(status: string, newRequestId?: string): string {
  if (newRequestId) {
    return `Reenviada con código de pedido: ${newRequestId}`;
  }
  if (isKeyOfStatus(status)) {
    return STATUS_DIC[status];
  }
  return status;
}

function getSubStatusName(subStatus: string, newRequestId?: string) {
  if (newRequestId) {
    return "";
  }
  if (isKeyOfSubestatus(subStatus)) {
    return SUBSTATUS_DIC[subStatus];
  }
  return subStatus;
}

export const formatTableData = ({
  data,
  handleOnClickOneDebt,
  isPending,
}: {
  data: RequestItem[];
  handleOnClickOneDebt?: Function;
  isPending: boolean;
}): TableProps => {
  const formatedData: { [key: string]: string | number | boolean }[] = data.map((request) => {
    // existe newRequestId cuando se repite un recobro "No realizado"
    const statusText = getStatusName(request.status, request.newRequestId);
    const subStatusText = getSubStatusName(request.subStatus, request.newRequestId);
    return {
      createdAt: formatDate(request.createdAt),
      updatedAt: formatDate(request.updatedAt),
      takerNif: request.takerNif,
      requestId: request.requestId,
      status: statusText,
      subStatus: subStatusText,
      noAction: request.status !== "N" || !!request.newRequestId,
      birthDate: request.fecNacimiento,
      codRamo: request.codRamo || "",
      codSubramo: request.codSubramo || "",
    };
  });
  if (isPending) {
    const actions: Action[] = [
      {
        icon: images.IconArrowCircularBlue,
        onClick: (rowData: { [key: string]: string | number | boolean }) =>
          handleOnClickOneDebt && handleOnClickOneDebt(rowData),
      },
    ];
    return {
      columns: columns,
      data: formatedData,
      actions: actions,
      actionsColumnName: "RECOBRO",
    };
  }

  return {
    columns: columns,
    data: formatedData,
  };
};
